
export default {
  actualSalesPosting: false,
  actualSalesErrors: [],
  actualSalesTotals: 0,
  actualSalesPosted: 0,
  
  mainListQuickFilters: [],
  quickFiltersDatesFrom: [],
  quickFiltersDatesTo: [],
}